import { AuthenticationErrorCode } from './authentication.error.codes';

export { AuthenticationErrorCode };

export enum AuthenticationErrorStatus {
    UserNotActive = 'User Not Active',
    UserDeleted = 'User Deleted',
    UserInactiveStatus = 'User Inactive Status',
    UserCannotLoginViaWeb = 'User cannot login via web',
    UserCannotLoginViaMobile = 'User cannot login via Mobile',
    UserCannotLoginViaManager = 'User cannot login via Manager',
    UserCannotLoginViaClient = 'User cannot login via Client Portal',
    UserCannotLoginViaSubcontractor = 'User cannot login via Subcontractor Portal',
    TokenWasUsed = 'The token is invalid',
    ConcurrentSessionLimitReached = 'Concurrent session limit reached',
    LoginsDisabled = 'Logins disabled'
}

export interface AuthenticationRoleSessionItem {
    id: string;
    startedAt: Date;
    browser?: string;
    os?: string;
}

export interface AuthenticationRoleResponse {
    success: boolean;
    token: string;
    refreshToken?: string;
    roleToken?: string;
    message?: string;
    errorStatus?: AuthenticationErrorStatus;
    errorCode?: AuthenticationErrorCode;
    limit?: number;
    sessions?: AuthenticationRoleSessionItem[];
    /** Portal sign-in only: names of the user's tenancies left out of the token because they are in maintenance mode. */
    maintenanceTenants?: string[];
}
